import { transparentize } from '../../../../theme-tools';
import { asMultiStyleConfig } from '../../../../utils/theme';
export var Header = asMultiStyleConfig({
  parts: ['mainContainer', 'navItem', 'menuButton', 'menuItem'],
  baseStyle: {
    mainContainer: {
      pt: '1.25rem',
      pb: '1rem',
      backgroundColor: 'blue.700'
    },
    navItem: {
      mr: '1.25rem'
    },
    menuButton: {
      color: 'white',
      _active: {
        bg: transparentize('green.500', 0.2)
      },
      _hover: {
        _after: {
          bg: 'none'
        }
      }
    },
    menuItem: {
      _focus: {
        bg: "blue.1140",
        outline: 'none'
      },
      _hover: {
        bg: 'blue.1140'
      },
      _active: {
        bg: "blue.1140"
      }
    }
  }
});